class DataSourceCharacteristicsDto {
    public ViewsLinkedToTables: boolean;
    public ReadSchemaAvailable: boolean;
    public CreateSchemaAvailable: boolean;
    public UpdateSchemaAvailable: boolean;
    public ReadAvailable: boolean;
    public CreateAvailable: boolean;
    public UpdateAvailable: boolean;
    public DeleteAvailable: boolean;

    constructor(
        viewsLinkedToTables: boolean,
        readSchemaAvailable: boolean,
        createSchemaAvailable: boolean,
        updateSchemaAvailable: boolean,
        readAvailable: boolean,
        createAvailable: boolean,
        updateAvailable: boolean,
        deleteAvailable: boolean
    ) {
        this.ViewsLinkedToTables = viewsLinkedToTables;
        this.ReadSchemaAvailable = readSchemaAvailable;
        this.CreateSchemaAvailable = createSchemaAvailable;
        this.UpdateSchemaAvailable = updateSchemaAvailable;
        this.ReadAvailable = readAvailable;
        this.CreateAvailable = createAvailable;
        this.UpdateAvailable = updateAvailable;
        this.DeleteAvailable = deleteAvailable;
    }
}

export default DataSourceCharacteristicsDto;
